/**
 * `wfScope` is the Workflows list scope ("This agent" vs "All workflows"). It
 * rides along so returning from a canvas — by the back arrow or the Workflows
 * tab, neither of which is a browser back — lands on the list the user was
 * actually on, rather than snapping to the default.
 */
const WORKSPACE_CONTEXT_KEYS = ["agentId", "channelId", "sessionId", "wfScope"] as const;

/**
 * Keep the selected agent, chat and workflow list scope when navigating to a
 * page outside the workspace route, such as a workflow canvas or run-history
 * page.
 */
export function withWorkspaceContext(
  path: string,
  source: URLSearchParams,
): string {
  const params = new URLSearchParams();
  for (const key of WORKSPACE_CONTEXT_KEYS) {
    const value = source.get(key);
    if (value) params.set(key, value);
  }

  const query = params.toString();
  if (!query) return path;
  return `${path}${path.includes("?") ? "&" : "?"}${query}`;
}
